import { StyleSheet } from '@react-pdf/renderer';

import theme from '@/theme/index';

export const styles = StyleSheet.create({
  pageStyle: {
    flexDirection: 'column',
    backgroundColor: theme.colors.light,
    padding: 10,
  },
  section: {
    padding: 10,
    position: 'relative',
  },
  headerStyle: {
    height: 40,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginTop: 10,
    marginBottom: 10,
    paddingLeft: 20,
    borderBottomWidth: 3,
    paddingBottom: 10,
    borderBottomColor: theme.colors.primary,
  },
  headerTitle: {
    color: theme.colors.primary,
    fontWeight: 'bold',
    fontSize: 22,
  },
  headerSubtitle: {
    fontSize: 22,
    color: theme.colors.primary,
    fontWeight: 'normal',
    fontStyle: 'italic',
    textAlign: 'left',
  },
  coverPageStyle: {
    flexDirection: 'column',
    backgroundColor: theme.colors.light,
    padding: 0,
    margin: 0,
  },
  coverPageContent: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: 20,
  },
  coverPageTitle: {
    color: theme.colors.light,
    fontWeight: 'bold',
    backgroundColor: theme.colors.primary,
    paddingLeft: 45,
    paddingRight: 15,
    paddingTop: 15,
    paddingBottom: 15,
    borderBottomRightRadius: 5,
    borderTopRightRadius: 5,
    fontSize: 24,
  },
  coverPageText: {
    color: theme.colors.primary,
    fontWeight: 'bold',
    fontSize: 24,
  },
  coverPageImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    position: 'absolute',
  },
  footerStyle: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    height: 40,
    backgroundColor: theme.colors.primary,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingLeft: 10,
    paddingRight: 10,
    marginTop: 10,
    zIndex: 1000,
  },

  contentTitle: {
    color: theme.colors.bluePrimary,
    width: 180,
    fontWeight: 'bold',
  },
  contentText: {
    color: theme.colors.dark,
    fontWeight: 'normal',
  },

  absoluteCenter: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  absoluteCenterLeft: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: 20,
  },
  absoluteBottom: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 20,
    zIndex: 1000,
    padding: '20px 100px',
  },

  infoRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },

  boxContainer: {
    flexDirection: 'row',
    gap: 10,
    justifyContent: 'space-between',
  },
  box: {
    flexDirection: 'column',
    gap: 5,
    borderWidth: 1,
    borderColor: theme.colors.grayLightAccent,
    borderRadius: 6,
    padding: 10,
    flex: 1,
  },
  boxTitle: {
    fontSize: 12,
    fontWeight: 'bold',
    paddingBottom: 5,
    borderBottomWidth: 1,
  },

  text: {
    color: theme.colors.dark,
    fontWeight: 'normal',
    fontSize: 12,
  },
  blueText: {
    color: theme.colors.bluePrimary,
    fontWeight: 'bold',
    fontSize: 12,
  },
  textBold: {
    color: theme.colors.dark,
    fontWeight: 'bold',
    fontSize: 12,
  },
  textItalic: {
    color: theme.colors.dark,
    fontWeight: 'normal',
    fontStyle: 'italic',
    fontSize: 12,
  },
  textBoldTitle: {
    color: theme.colors.dark,
    fontWeight: 'bold',
    fontSize: 16,
  },

  contentRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 15,
    paddingVertical: 5,
  },
  contentNumberContainer: {
    width: 30,
    height: 30,
    borderRadius: 15,
    backgroundColor: theme.colors.primary,
    alignItems: 'center',
    justifyContent: 'center',
  },
  contentNumber: {
    color: theme.colors.light,
    fontWeight: 'bold',
    fontSize: 14,
  },
  contentTextContainer: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottomWidth: 1,
    borderBottomColor: theme.colors.grayLightAccent,
    paddingBottom: 5,
  },
  contentTitleText: {
    color: theme.colors.primary,
    fontWeight: 'bold',
    fontSize: 14,
  },
  contentPageNumber: {
    color: theme.colors.bluePrimary,
    fontSize: 12,
    fontWeight: 'normal',
  },
});
